import { useState, useCallback } from 'react';

export function useEditModal() {
  const [open, setOpen] = useState(false);
  const [entity, setEntity] = useState(null);

  const openModal = useCallback((value) => {
    setEntity(value);
    setOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setOpen(false);
    setEntity(null);
  }, []);

  return {
    open,
    entity,
    openModal,
    closeModal,
  };
}